import { Component, forwardRef, HostBinding, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { MuiIconFont } from '../../icon';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ToggleComponentBase } from '../toggle';

let nextUniqueId = 0;

@Component({
  selector: 'mui-icon-toggle-button',
  templateUrl: './mui-icon-toggle-button.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MuiIconToggleButton),
      multi: true
    }
  ],
  styleUrls: ['./mui-icon-toggle-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MuiIconToggleButton extends ToggleComponentBase {
  @Input()
  @HostBinding('attr.tabindex')
  get tabindex(): number | string {
    return this._disabled ? -1 : this._tabindex;
  }

  set tabindex(value: number | string) {
    this._tabindex = value;
  }

  @Input()
  iconName = 'check';

  @Input()
  iconFont: MuiIconFont | string = MuiIconFont.FONTAWESOME;

  @Input()
  @HostBinding('class.mui-icon-toggle-button--small')
  small = false;

  @Input()
  @HostBinding('attr.aria-label')
  label: string | null = null;

  @HostBinding('attr.role')
  readonly role = 'button';

  private _tabindex: number | string = 0;

  @HostBinding('attr.aria-pressed')
  get ariaChecked(): boolean | 'mixed' {
    return this.indeterminate ? 'mixed' : this.checked;
  }

  @HostBinding('attr.aria-disabled')
  get ariaDisabled(): boolean | null {
    return this._disabled;
  }

  @HostBinding('attr.disabled')
  private get disabledAttribute(): boolean | null {
    return this.disabled ? true : null;
  }

  @HostBinding('class.mui-icon-toggle-button')
  private _baseClass = true;

  protected _uid = `mui-icon-toggle-button-${nextUniqueId++}`;

  @HostListener('click', ['$event'])
  @HostListener('keydown.space', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  toggleState(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.disabled) {
      return;
    }

    const newValue = this.indeterminate ? true : !this.checked;
    this.setInternalValue(newValue);
    this.propagateChange(newValue);
  }
}
